
export default () => ({
    platos: [],
    entradas: null,
    dataLoaded: false,
})